<template>
    <div class="bg-white w-full mt-5 p-4 mb-16 lg:mb-6 rounded overflow-hidden">
        <h3 class="font-bold text-xl page-title mb-8">
            {{ $__('dashboard.contact') }}
        </h3>
        <img class="rounded-full w-12 h-12 mb-4 object-cover" :src="user.accountManagerPicture" alt="">
        <strong class="block text-base font-black">{{ user.accountManagerName }}</strong>
        <span class="text-gray-500 text-sm font-semibold block pb-3 border-b border-gray-200">{{ user.accountManagerTitle ? 'Dyflexis ' + user.accountManagerTitle : '' }}</span>
        <div class="flex items-center border-b border-gray-200 py-3">
            <EnvelopeLight />
            <a class="ml-4 text-blue-700 underline break-all"
               :href="'mailto:' + user.accountManagerEmail">{{ user.accountManagerEmail }}</a>
        </div>
        <div class="flex py-3 items-center">
            <PhoneSolid />
            <a :href="'tel:' + user.accountManagerPhone" class="ml-4">{{ user.accountManagerPhone }}</a>
        </div>
    </div>
</template>

<script>
import EnvelopeLight from "@/Components/Icons/EnvelopeLight";
import PhoneSolid from "@/Components/Icons/PhoneSolid";

export default {
    props: ['user'],
    components: {PhoneSolid, EnvelopeLight}
}
</script>
